import AdminInfo from './AdminInfo'

export default AdminInfo
